<template>
  <div class="article">
    <CMessage :messages="message.base" />
    <div v-html="privacies.body" />
  </div>
</template>

<script>
import ApiRequestor from '../common/ApiRequestor'
export default {
  name: "Privacies",
  data: function () {
    return {
     message: {},
      privacies: {
        title: '',
        body: ''
      }
    }
  },
  created() {
    this.load()
  },
  methods: {
    load() {
      ApiRequestor.get('privacy/articles/latest').then(
        response => {
          this.privacies = response.data
        },
        error => {
          this.message = error.response.data
        }
      );
    }
  }
}
</script>